"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDomain = void 0;
const basic_types_1 = require("../constants/generated/basic-types");
const non_standard_domain_json_1 = __importDefault(require("../constants/generated/non-standard-domain.json"));
const get_supported_countries_1 = require("./get-supported-countries");
const domainNamesByBrand = {
    BK: 'burgerking',
    FHS: 'firehousesubs',
    PLK: 'popeyes',
    TH: 'timhortons',
};
/**
 * Get a market's Fully-Qualified Domain Name.
 * Note this provides a naked domain name, i.e. no `www.` is included.
 * @param brand brand code.
 * @param iso2 country code.
 * @returns market's FQDN when available, otherwise undefined.
 */
const getDomain = (brand, iso2) => {
    const supportedBrand = (0, basic_types_1.asBrand)(brand);
    const supportedCountry = (0, basic_types_1.asIsoCountryCode2)(iso2);
    if (!supportedBrand || !supportedCountry) {
        return;
    }
    if (!(0, get_supported_countries_1.getSupportedCountries)({ brands: [supportedBrand] }).includes(supportedCountry)) {
        return;
    }
    const marketException = non_standard_domain_json_1.default[supportedBrand][supportedCountry];
    if (marketException) {
        return marketException;
    }
    return `${domainNamesByBrand[supportedBrand]}.${iso2.toLowerCase()}`;
};
exports.getDomain = getDomain;
